import omniKeywordSegmentService from './reducers';

import * as omniKeywordListOperation from './operation';
import * as omniKeyWordType from './types';
import * as omniKeywordAction from './actions';

export { omniKeywordListOperation, omniKeyWordType, omniKeywordAction };

export default omniKeywordSegmentService;
